
import TermChip from './TermChip';
import Actions from './Actions';

export default function AttributeRow({ attr, expanded, toggle, openTermModal, openEditModal, openAttributeEditModal }) {
  return (
    <>
      <tr className={`odd:bg-white even:bg-gray-50 hover:bg-gray-100`}>
        <td className="px-4 py-3 whitespace-nowrap text-base font-semibold text-gray-900">{attr.name}</td>
        <td className="px-4 py-3 whitespace-nowrap text-base text-gray-600">{attr.taxonomy}</td>
        <td className="px-4 py-3 whitespace-nowrap text-center text-base text-gray-700">{attr.terms_count}</td>
        <td className="px-4 py-3 whitespace-nowrap text-base text-gray-700">
          <Actions
            attr={attr}
            expanded={expanded}
            toggle={() => toggle(attr.taxonomy)}
            openTermModal={() => openTermModal(attr.taxonomy, attr.type)}
            openAttributeEditModal={() => openAttributeEditModal(attr)}
          />
        </td>
      </tr>

      {expanded && (
        <tr className="bg-gray-50">
          <td colSpan={4} className="px-4 py-3">
            <div className="flex flex-wrap gap-2">
                  {(attr.terms && attr.terms.length) ? attr.terms.map((t) => (
                    <TermChip key={t.term_id} t={t} attr={attr} openEdit={() => openEditModal(t, attr.type, attr.taxonomy)} />
                  )) : <div className="text-sm text-gray-500">No terms found.</div>}
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
